import { MutableRefObject, useEffect, useState } from 'react';
import { useThrottle } from './useThrottle';

/** Хук для получения координат элемента,
 * отслеживает события скролла и изменение размеров окна
 * @param ref - ссылка на элемент
 * @param delay - задержка обновления состояния default = 0
 */
export const usePosition = <T extends HTMLElement | null = HTMLElement>(ref?: MutableRefObject<T>, delay = 0) => {
  const [position, setPosition] = useState<DOMRect | undefined>(undefined);

  const handleChange = useThrottle(() => {
    if (ref?.current) {
      const rect = ref.current.getBoundingClientRect();
      setPosition(rect);
    }
  }, delay);

  /** Получаем сразу позицию при получении актуальной ссылки */
  useEffect(() => {
    if (ref?.current) {
      handleChange();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref?.current]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleChange);
      window.addEventListener('resize', handleChange);

      return () => {
        window.removeEventListener('scroll', handleChange);
        window.removeEventListener('resize', handleChange);
      };
    }
  }, [handleChange]);

  return position;
};
